import { getOpenId, getHotSearch, getPrice,getPrintPrice } from '../data/api';
import { RECORD_USERINFO, RECORD_HOTSEARCH, RECORD_SERVICE_TEL, RECORD_PRICE,RECORD_PRINTPRICE } from './mutation-types';
import { showLoading, hideLoading } from '../utils/alipay';

export default {
  async getUserInfo({ commit, state }, authCode) {
    let  res = await getOpenId(authCode);
    commit(RECORD_USERINFO, res.data.alipay_user_id);
  },
  async getHotSearch({ commit, state }) {
    let res = await getHotSearch();
    commit(RECORD_HOTSEARCH, res.data.result);
  },
  async getPrice({commit,state}) {
    ap.showLoading();
    let {data: { order, print_order, urgent_print_order}} = await getPrice();
    const price = {
      digitalPhoto: order,
    };
    commit(RECORD_PRICE, price);
  },
  async getPrintPrice({commit,state}) {
    ap.showLoading();
    let res = await getPrintPrice();
    console.log(res)
    const printPrice = {
			normal:res.data.result.normal/100,
			urgent:res.data.result.urgent/100
    };
    commit(RECORD_PRINTPRICE, printPrice);
  }
}